import React, { useEffect, useState } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import TableRow from '@material-ui/core/TableRow'
import { juryoMobileDetailTable } from 'assets/TableHeader'
import A_TableCellCheck from 'components/1_Atoms/A_TableCellCheck'
import A_TableCellText from 'components/1_Atoms/A_TableCellText'

const useStyles = makeStyles(() =>
  createStyles({
    table: {
      width: '100%',
      // backgroundColor: '#66FF99',
    },
  }),
)

const width = juryoMobileDetailTable.width
console.log(width)
const label = juryoMobileDetailTable.label

type Props = {
  click: (e: React.MouseEvent<HTMLButtonElement, MouseEvent> | React.MouseEvent<HTMLTableRowElement, MouseEvent>, isChecked: boolean) => void
  isChecked: boolean
  selectListCount: number
  refs: React.MutableRefObject<React.RefObject<HTMLTableCellElement>[]>
}

const O_TableHeaderJokenMobileDetail = ({ click, isChecked, selectListCount, refs }: Props) => {
  const classes = useStyles()

  // 固定する項目のleftを保持
  const [leftList, setLeftList] = useState<number[]>([])
  useEffect(() => {
    // 固定する項目のleftを算出
    const getLeft = (index: number) => {
      return refs.current?.reduce((prev, curr, i) => {
        if (i >= index) return prev
        if (curr.current?.getBoundingClientRect().width) prev = prev + Math.round(curr.current?.getBoundingClientRect().width * 100) / 100
        return prev
      }, 0)
    }
    const list = []
    for (let i = 0; i < refs.current.length; i++) list.push(getLeft(i))
    setLeftList(list)
  }, [...refs.current, selectListCount])

  return (
    <TableRow
      hover //
      onClick={(e) => click(e, isChecked)}
      className={classes.table}
    >
      {/* チェックボックス */}
      <A_TableCellCheck //
        isChecked={isChecked}
        refs={refs.current}
        refIndex={0}
        left={leftList[0]}
        color="#66FF99"
      />
      {/* JANコード */}
      <A_TableCellText //
        width={width.JAN_CD}
        title={label.JAN_CD}
        data={label.JAN_CD}
        refIndex={1}
        left={leftList[1]}
        caption={false}
        color="#66FF99"
        align="center"
      />
      {/* 品名 */}
      <A_TableCellText //
        width={width.SHOHIN}
        title={label.SHOHIN}
        data={label.SHOHIN}
        caption={false}
        color="#66FF99"
        align="center"
      />
      {/* 規格 */}
      <A_TableCellText //
        width={width.KIKAKU}
        title={label.KIKAKU}
        data={label.KIKAKU}
        caption={false}
        color="#66FF99"
        align="center"
      />
      {/* 発注数 */}
      <A_TableCellText //
        width={width.SURYO}
        title={label.SURYO}
        data={label.SURYO}
        caption={false}
        color="#66FF99"
        align="center"
      />
      {/* 納品数 */}
      <A_TableCellText //
        width={width.NOHIN_SURYO}
        title={label.NOHIN_SURYO}
        data={label.NOHIN_SURYO}
        caption={false}
        color="#66FF99"
        align="center"
      />
      {/* 内容確認依頼 */}
      <A_TableCellText //
        width={width.NAIYO}
        title={label.NAIYO}
        data={label.NAIYO}
        caption={false}
        color="#66FF99"
        align="center"
      />
      {/* 伝票番号 */}
      <A_TableCellText //
        width={width.DENPYO_NO}
        title={label.DENPYO_NO}
        data={label.DENPYO_NO}
        caption={false}
        color="#66FF99"
        align="center"
      />
      {/* 原単価 */}
      <A_TableCellText //
        width={width.GEN_TANKA}
        title={label.GEN_TANKA}
        data={label.GEN_TANKA}
        caption={false}
        color="#66FF99"
        align="center"
      />
      {/* 売単価 */}
      <A_TableCellText //
        width={width.BAI_TANKA}
        title={label.BAI_TANKA}
        data={label.BAI_TANKA}
        caption={false}
        color="#66FF99"
        align="center"
      />
      {/* 原価金額 */}
      <A_TableCellText //
        width={width.GENKA}
        title={label.GENKA}
        data={label.GENKA}
        caption={false}
        color="#66FF99"
        align="center"
      />
      {/* 売価金額 */}
      <A_TableCellText //
        width={width.BAIKA}
        title={label.BAIKA}
        data={label.BAIKA}
        caption={false}
        color="#66FF99"
        align="center"
      />
      {/* 受領区分 */}
      <A_TableCellText //
        width={width.JURYO_KBN}
        title={label.JURYO_KBN}
        data={label.JURYO_KBN}
        caption={false}
        color="#66FF99"
        align="center"
      />
    </TableRow>
  )
}

export default React.memo(O_TableHeaderJokenMobileDetail)
